import Page from "webPage/Page";
import $ from "jquery";
import ProductComparisonTable from "util/ProductComparisonTable";
import ProductImageModal from "modal/ProductImageModal";

Page.register(['tax-solutions-sectors'], () => {

    $('body').on('click', '.js-product-image-modal', function () {
        let images = JSON.parse($(this).find('.js-images').text());
        (new ProductImageModal(images)).show();
        return false;
    });

    let $comparison_section = $('.js-comparison-section');

    if ($comparison_section.length > 0) {
        new ProductComparisonTable($comparison_section);
    }

    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-breadcrumb',
    //     duration: sectionGetHeight('.js-parallax-breadcrumb'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-breadcrumb-circle', 1, {yPercent: 10}, {yPercent: -10}),
    //     TweenMax.fromTo('.js-breadcrumb-text', 1, {yPercent: 10}, {yPercent: -5}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-series',
    //     duration: sectionGetHeight('.js-parallax-series'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-series-circle-1', 1, {yPercent: 10}, {yPercent: -10}),
    //     TweenMax.fromTo('.js-series-circle-2', 1, {yPercent: -10}, {yPercent: 10}),
    //     TweenMax.fromTo('.js-series-text', 1, {yPercent: 10}, {yPercent: -5}),
    // ])));
    //
    // registerScene(new ScrollMagic.Scene({
    //     triggerElement: '.js-parallax-why',
    //     duration: sectionGetHeight('.js-parallax-why'),
    //     triggerHook: "onEnter",
    // }).setTween(new TimelineMax().add([
    //     TweenMax.fromTo('.js-why-text', 1, {yPercent: 10}, {yPercent: -5}),
    // ])));
});